export default __webpack_public_path__ + "static/media/plantVase.8735df85.png";